import { useEffect, useState } from "react";
import brandLogo from "../assets/images/logo-elya.png";
import mobileBackground from "../assets/images/mobile-still.png";
import IconWrapper from "../components/IconWrapper";
import { DynamicFrame } from "../components/VideoModal";
import socialLinks from "../config/socialLinks";
import { services } from "../Views/Header";
import "./Mobile.css";

console.log("Services:", services);

const CVButton = ({ onClick, onError }) => {
  const handleClick = async () => {
    onClick?.();

    try {
      const link = document.createElement("a");
      link.href = "/CV.pdf";
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      onError?.(error);
    }
  };

  return (
    <div className="mobile-cta">
      <button className="mobile-cta__btn" type="button" onClick={handleClick}>
        CV.PDF
      </button>
    </div>
  );
};

const Socials = () => {
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <div className="mobile-socials-icons">
      {socialLinks.map(({ name, url, icon, size }) => (
        <button
          type="button"
          key={name}
          onClick={() => openInNewTab(url)}
          className="mobile-socials-icon"
          aria-label={name}
        >
          <IconWrapper
            iconName={icon}
            className="mobile-socials-icon__svg"
            width={size || 28}
            height={size || 28}
          />
        </button>
      ))}
    </div>
  );
};

const Contact = () => {
  const [copiedItem, setCopiedItem] = useState(null);

  const handleCopyToClipboard = (text, itemId) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopiedItem(itemId);
        setTimeout(() => setCopiedItem(null), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy to clipboard:", err);
      });
  };

  return (
    <div className="mobile-contact">
      <div
        className={`mobile-contact__item ${
          copiedItem === "email" ? "copy-success" : ""
        }`}
      >
        elya@2l-lab.com
        <button
          type="button"
          onClick={() => handleCopyToClipboard("elya@2l-lab.com", "email")}
          className="mobile-contact__copy"
          aria-label="Copy email address"
        >
          <IconWrapper iconName="copy" className="mobile-contact__icon" />
        </button>
      </div>
      <div
        className={`mobile-contact__item ${
          copiedItem === "phone" ? "copy-success" : ""
        }`}
      >
        +33 6 85 38 36 13
        <button
          type="button"
          onClick={() => handleCopyToClipboard("+33 6 85 38 36 13", "phone")}
          className="mobile-contact__copy"
          aria-label="Copy phone number"
        >
          <IconWrapper iconName="copy" className="mobile-contact__icon" />
        </button>
      </div>
    </div>
  );
};

const Mobile = () => {
  const [cvError, setCvError] = useState(null);
  const [showNarrative, setShowNarrative] = useState(false);

  useEffect(() => {
    if (showNarrative) {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [showNarrative]);

  return (
    <div className="mobile-layout">
      <header
        className="mobile-header"
        style={{ backgroundImage: `url(${mobileBackground})` }}
      >
        <img src={brandLogo} alt="Logo" className="header__logo" />
      </header>
      <div className="mobile-content">
        <h1 className="mobile-headline">
          <span className="mobile-headline__firstname">Elya</span>
          <br />
          <span className="mobile-headline__lastname">Randrianaivo</span>
          <br />
          <span className="mobile-headline__title">DIRECTOR</span>
        </h1>
        <div className="mobile-video">
          <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
            <iframe
              src="https://player.vimeo.com/video/1188171515?h=c1fc6e9bae&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ELYA DIRECTOR REEL - COMMERCIAL"
            ></iframe>
          </div>
          <script src="https://player.vimeo.com/api/player.js"></script>
        </div>
        <div className="mobile-video__label">
          DEMO - MINI-CONCEPTS PUB LIFESTYLE
        </div>
      </div>
      {/* TODO: Test error UI */}
      {cvError && <p className="mobile__error">{cvError}</p>}
      <CVButton
        onClick={() => {
          setCvError(null);
        }}
        onError={(error) => {
          console.error("Error opening CV:", error);
          setCvError("Failed to download CV.");
        }}
      />
      <Contact />
      <Socials />
      <div className="mobile-narrative">
        {
          !showNarrative ? (
            <button
              type="button"
              className="mobile-narrative__trigger"
              onClick={() => setShowNarrative(true)}
              aria-label="Explore filmography highlights"
            >
              <span className="mobile-narrative__title">
                Corporate & Filmography
              </span>
              <p className="mobile-narrative__link">
                Explore more work <span>→</span>
              </p>
            </button>
          ) : (
            services.map((service) => (
              <div key={service.id} className="mobile-narrative__video-wrapper">
                <div className="mobile-narrative__title">{`${service.title} - ${service.description}`}</div>
                <div className="mobile-video">
                  <div
                    style={{ padding: "56.25% 0 0 0", position: "relative" }}
                  >
                    <DynamicFrame videoId={service.id} />
                  </div>
                  <script src="https://player.vimeo.com/api/player.js"></script>
                </div>
              </div>
            ))
          )
          // <>
          //   <div className="mobile-narrative__video-wrapper">
          //     <div className="mobile-narrative__title">
          //       REEL - SELECTED NARRATIVES
          //     </div>
          //     <div className="mobile-video">
          //       <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
          //         <DynamicFrame videoId="corporate" />
          //       </div>
          //       <script src="https://player.vimeo.com/api/player.js"></script>
          //     </div>
          //   </div>
          //   <div className="mobile-narrative__video-wrapper">
          //     <div className="mobile-narrative__title">
          //       REEL - SELECTED NARRATIVES
          //     </div>
          //     <div className="mobile-video">
          //       <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
          //         <DynamicFrame videoId="doc" />
          //       </div>
          //       <script src="https://player.vimeo.com/api/player.js"></script>
          //     </div>
          //   </div>
          //   <div className="mobile-narrative__video-wrapper">
          //     <div className="mobile-narrative__title">
          //       REEL - SELECTED NARRATIVES
          //     </div>
          //     <div className="mobile-video">
          //       <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
          //         <DynamicFrame videoId="drama" />
          //       </div>
          //       <script src="https://player.vimeo.com/api/player.js"></script>
          //     </div>
          //   </div>
          // </>
        }
      </div>
      <footer className="mobile-footer">
        {/* Subtle Back to Top */}
        <button
          type="button"
          className="mobile-footer__btn"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          ↑
        </button>
        {/* Signature */}
        <p>
          Designed & Directed by Elya Randrianaivo
          <br />© 2026 All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default Mobile;
